import { QuoteCurrencyList } from './constants/currency';
import { isNullable } from './nullable';
import Num from './num';

const NumberRegex = /^\d/;

export const instrumentsSort = (a: string, b: string) => {
  const isAStartNumber = NumberRegex.test(a);
  const isBStartNumber = NumberRegex.test(b);
  if (isAStartNumber && !isBStartNumber) return 1;
  if (!isAStartNumber && isBStartNumber) return -1;

  const parseSymbol = (symbol: string) => {
    const isSpot = !symbol.endsWith('.PERP');
    const baseSymbol = isSpot ? symbol : symbol.replace('.PERP', '');

    for (const currency of QuoteCurrencyList) {
      if (baseSymbol.endsWith(currency)) {
        return {
          base: baseSymbol.slice(0, -currency.length),
          currency,
          isSpot,
        };
      }
    }

    return { base: baseSymbol, currency: '', isSpot };
  };

  const parsedA = parseSymbol(a);
  const parsedB = parseSymbol(b);

  if (parsedA.base === parsedB.base && parsedA.currency && parsedB.currency) {
    if (!parsedA.isSpot && parsedB.isSpot) return -1;
    if (parsedA.isSpot && !parsedB.isSpot) return 1;

    const indexA = QuoteCurrencyList.indexOf(parsedA.currency as (typeof QuoteCurrencyList)[number]);
    const indexB = QuoteCurrencyList.indexOf(parsedB.currency as (typeof QuoteCurrencyList)[number]);

    const allInList = indexA !== -1 && indexB !== -1;
    if (allInList) return indexA - indexB;
    if (indexA !== -1 && indexB === -1) return -1;
    if (indexA === -1 && indexB !== -1) return 1;

    return parsedA.currency.localeCompare(parsedB.currency);
  }

  return a.localeCompare(b);
};

interface SortablePosition {
  symbol: string;
}

export const positionOrderSort = (a: SortablePosition, b: SortablePosition) => {
  return a.symbol.localeCompare(b.symbol);
};

interface Options {
  type: 'string' | 'number' | 'bignumber';
  order: 'asc' | 'desc';
}

export const sortingHelper = <T extends string | number>(a: T, b: T, options: Options) => {
  if (isNullable(a) || isNullable(b)) return 0;
  const compareA = options.order === 'asc' ? a : b;
  const compareB = options.order === 'asc' ? b : a;

  if (options.type === 'number') {
    if (compareA < compareB) return -1;
    if (compareA > compareB) return 1;
    return 0;
  }
  if (options.type === 'bignumber') {
    if (Num(compareA).isLessThan(compareB)) return -1;
    if (Num(compareA).isGreaterThan(compareB)) return 1;
    return 0;
  }
  return (compareA as string).localeCompare(compareB as string);
};
